
import BaseTable from "@/components/BaseTable/index.vue";
import { Component, Vue } from "vue-property-decorator";
import {
  deletedSn,
  exportNoSn,
  exportSn,
  getSnResult,
  searchHqProductNumber,
  uploadSn,
  uploadSnResult,
} from "@/api/product-number";
import Pagination from "@/components/Pagination/index.vue";
import NumberMove from "@/views-oms/product-business-management/product-hierarchy-management/number/numberMove.vue";
import { ICustomerModel } from "@/api/types";
import { searchCustomer } from "@/api/customer";

@Component({
  name: "ProductNumberList",
  components: { NumberMove, Pagination, BaseTable },
})
export default class extends Vue {
  private name = "";
  private total = 0;
  private productId = "";
  private SNumber = "";
  private resDate = [];
  private tableCol = [];
  private moveVisible = false;
  private fileUpload = false;
  private currentSn = "";
  private currentSnId = "";
  private files = [];
  private uploadType = "";
  private isSearchingCustomers = false;
  private customers: any[] = [];
  private query: any = {
    pageNumber: 1,
    pageSize: 10,
    number: "",
  };

  created() {
    this.productId = this.$router.currentRoute.query.id as any;
    this.name = this.$router.currentRoute.query.name as any;
    this.currentSn = "";

    this.tableCol = [
      {
        label: "S/N编号",
        prop: "sn",
        key: "sn",
        width: "70",
      },
      {
        label: "编号单元数量",
        prop: "count",
        key: "count",
        width: "70",
      },
      {
        label: "操作",
        prop: "actions",
        key: "actions",
        type: "actions",
        options: [
          {
            name: "单元管理",
            click: "unitManage",
            render: () => {
              return true;
            },
          },
          // {
          //   name: "删除",
          //   click: "deleteNumber",
          //   render: () => {
          //     return this.SNumber != "无S/N编号产品";
          //   }
          // },
          // {
          //   name: "S/N迁移",
          //   click: "snMigration",
          //   render: () => {
          //     return this.SNumber != "无S/N编号产品";
          //   }
          // }
        ],
        width: "80",
        show: true,
      },
    ];
    this.getNumberList(); // 这里是调用的接口;
  }
  private searchCustomers(a) {
    this.isSearchingCustomers = true;
    searchCustomer({ keyword: a })
      .then((res: any) => {
        this.customers = res;
        this.isSearchingCustomers = false;
      })
      .catch(() => {
        this.isSearchingCustomers = false;
      });
  }
  public loading: Boolean = false;
  private async getNumberList() {
    this.loading = true;
    let res: any = await searchHqProductNumber(
      { ...this.query },
      this.productId
    );
    this.resDate = res.list;
    this.loading = false;
    this.total = +res.total;
    this.query.pageSize = +res.size;
    this.query.pageNumber = +res.page;
  }

  private toNumberType() {
    this.$router.push({
      name: "ProductNumberTypeManagement",
    });
  }

  private addFile(file) {
    this.files.push(file);
  }

  private uploadSn() {
    this.fileUpload = true;
    this.uploadType = "sn";
  }

  private uploadSnResult() {
    this.fileUpload = true;
    this.uploadType = "snResult";
  }

  private async handleUpload() {
    if (this.files.length == 0) {
      return;
    }
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    let axiosPromise;
    if (this.uploadType == "sn") {
      axiosPromise = uploadSn(this.productId, formData);
    } else if (this.uploadType == "snResult") {
      axiosPromise = uploadSnResult(this.productId, formData);
    }
    await axiosPromise.then(() => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.fileUpload = false;
      this.files = [];
      this.getNumberList();
    });
  }

  private deleteNumber(scoop) {
    deletedSn(scoop.row.id).then(() => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.getNumberList();
    });
  }

  private unitManage(scoop) {
    this.$router.push({
      path: "hqProductNumberUnitList",
      query: {
        id: scoop.row.id,
        name: this.name,
        productId: this.productId,
        sn: scoop.row.sn,
      },
    });
  }

  private async exportAllSn() {
    await exportSn(this.productId).then((res: any) => {
      this.createFile(res, "SN全部编号导出" + Date.now() + ".xlsx");
    });
  }

  private createFile(res: any, fileName: string) {
    let blob = new Blob([res.data]);
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }

  private async exportNoSn() {
    await exportNoSn(this.productId).then((res: any) => {
      this.createFile(res, "无SN编号产品导出" + Date.now() + ".xlsx");
    });
  }

  private async matchSn() {
    await getSnResult(this.productId).then((res: any) => {
      this.createFile(res, "SN匹配结果导出" + Date.now() + ".xlsx");
    });
  }

  private snMigration(scoop) {
    this.currentSn = scoop.row.sn;
    this.currentSnId = scoop.row.id;
    this.moveVisible = true;
  }
}
